import React, { Component } from "react";
import {
  Typography,
  message,
  Alert,
  Row,
  Col,
  Divider,
  Tag,
  Checkbox,
} from "antd";
import {
  SolutionOutlined,
  CarOutlined,
  CheckCircleOutlined,
  NumberOutlined,
} from "@ant-design/icons";
import { connect } from "react-redux";
import axios from "axios";
import { ModalItem, ButtonItem } from "../../../../Components/Items";

const { Text } = Typography;

// Configuración visual por estado destino. Comparte mapa con el panel principal.
const ESTADO_CONFIG = {
  3: {
    titulo: "Confirmar paso a Orden de Entrega",
    icon: <SolutionOutlined />,
    descripcion:
      "Al confirmar, este paquete pasará a 'Orden de Entrega', listo para salir hacia el cliente.",
    cta: "Sí, está listo para entregarse",
    color: "#722ed1",
  },
  4: {
    titulo: "Confirmar salida a tránsito",
    icon: <CarOutlined />,
    descripcion:
      "Al confirmar, este paquete pasará a 'En tránsito' y el cliente podrá darle seguimiento.",
    cta: "Sí, ya está en tránsito",
    color: "#1890ff",
  },
  5: {
    titulo: "Confirmar entrega del pedido",
    icon: <CheckCircleOutlined />,
    descripcion:
      "Al confirmar, este paquete quedará marcado como entregado.",
    cta: "Sí, fue entregado",
    color: "#52c41a",
  },
};

class ModalConfirmarEstadoConCorreo extends Component {
  state = {
    cargando: false,
    enviarCorreo: this.props.enviarCorreoDefault !== false,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.setState({ enviarCorreo: this.props.enviarCorreoDefault !== false });
    }
  }

  confirmar = () => {
    const {
      venta,
      origenKey,
      nuevoEstado,
      empresaId,
      headersToken,
      onSuccess,
    } = this.props;
    const { enviarCorreo } = this.state;

    this.setState({ cargando: true });

    axios
      .post(
        "ventasEcommerce/actualizarEstadoPaquete",
        {
          empresaId,
          ventaId: venta._id,
          origenKey,
          nuevoEstado,
          enviarCorreo,
        },
        { headers: headersToken },
      )
      .then((res) => {
        this.setState({ cargando: false });
        if (res.data.success === 1) {
          message.success("Estado actualizado");
          onSuccess();
        } else {
          message.warning(res.data.message);
        }
      })
      .catch(() => {
        this.setState({ cargando: false });
        message.error("Error al conectar con el servidor.");
      });
  };

  render() {
    const { visible, onCancel, venta, envio, nuevoEstado } = this.props;
    const { cargando, enviarCorreo } = this.state;

    if (!venta || !envio) return null;

    const cfg = ESTADO_CONFIG[nuevoEstado] || ESTADO_CONFIG[4];
    const nombreCliente = `${venta.clienteOnline?.nombre || ""} ${venta.clienteOnline?.apellidoPaterno || ""}`.trim();

    return (
      <ModalItem
        title={
          <span>
            {cfg.icon} {cfg.titulo}
          </span>
        }
        visible={visible}
        onCancel={onCancel}
        width={520}
        spinning={cargando}
      >
        <Alert
          message={cfg.descripcion}
          type="info"
          showIcon
          style={{ marginBottom: 15, marginTop: 15 }}
        />

        <div
          style={{
            background: "#f5f5f5",
            padding: "15px",
            borderRadius: "8px",
            marginBottom: "15px",
          }}
        >
          <Row gutter={[0, 10]}>
            <Col span={24}>
              <Text type="secondary" style={{ fontSize: "12px" }}>
                Folio de Venta:
              </Text>
              <br />
              <Text strong>{venta.serieNumero}</Text>
            </Col>
            <Col span={24}>
              <Text type="secondary" style={{ fontSize: "12px" }}>
                Cliente:
              </Text>
              <br />
              <Text strong>{nombreCliente}</Text>
            </Col>
            {(envio.carrier || envio.trackingNumber) && (
              <>
                <Divider style={{ margin: "8px 0" }} />
                {envio.carrier && (
                  <Col span={12}>
                    <Text type="secondary" style={{ fontSize: "12px" }}>
                      Paquetería / Origen:
                    </Text>
                    <br />
                    <Tag color="orange">{envio.carrier?.toString().toUpperCase()}</Tag>
                  </Col>
                )}
                {envio.trackingNumber && (
                  <Col span={12}>
                    <Text type="secondary" style={{ fontSize: "12px" }}>
                      Guía / Rastreo:
                    </Text>
                    <br />
                    <Text strong>
                      <NumberOutlined /> {envio.trackingNumber}
                    </Text>
                  </Col>
                )}
              </>
            )}
          </Row>
        </div>

        <Checkbox
          checked={enviarCorreo}
          onChange={(e) => this.setState({ enviarCorreo: e.target.checked })}
        >
          Enviar correo al cliente con la actualización del estado
        </Checkbox>

        <div style={{ textAlign: "right", marginTop: 20 }}>
          <ButtonItem onClick={onCancel} blanco style={{ marginRight: 8 }}>
            Cancelar
          </ButtonItem>
          <ButtonItem
            type="primary"
            style={{
              backgroundColor: cfg.color,
              borderColor: cfg.color,
              color: "white",
            }}
            icon={<CheckCircleOutlined />}
            onClick={this.confirmar}
          >
            {cfg.cta}
          </ButtonItem>
        </div>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalConfirmarEstadoConCorreo);
